const types = {
  'SELECT_IDENTS': 'SELECT_IDENTS',
  'RECEIVER_ADDRESS': 'RECEIVER_ADDRESS'
}
const purchase = {
  state: {
    /** 被选中商品的idents */
    [types.SELECT_IDENTS]: [],
    /** 收货地址 */
    [types.RECEIVER_ADDRESS]: null
  },
  actions: {
    [types.SELECT_IDENTS]: ({ commit, state }, { ident, isSelect }) => {
      let selectIdents = [...state[types.SELECT_IDENTS]]
      if (isSelect) { // 选中 向SELECT_IDENTS push ident
        if (Array.isArray(ident)) {
          if (ident.length === 0) { // 如果传的是空数组，清空SELECT_IDENTS
            selectIdents = []
          } else {
            selectIdents.push(...ident)
          }
        } else {
          selectIdents.push(ident)
        }
      } else {
        if (Array.isArray(ident)) {
          selectIdents = ident.filter(item => {
            return !selectIdents.includes(item)
          })
        } else {
          selectIdents.splice(selectIdents.indexOf(ident), 1)
        }
      }
      return commit(types.SELECT_IDENTS, [...new Set(selectIdents)])
    },
    [types.RECEIVER_ADDRESS]: ({ commit }, data) => {
      return commit(types.RECEIVER_ADDRESS, data)
    }
  },
  mutations: {
    [types.SELECT_IDENTS]: (state, res) => {
      state[types.SELECT_IDENTS] = res
    },
    [types.RECEIVER_ADDRESS]: (state, res) => {
      state[types.RECEIVER_ADDRESS] = res
    }
  },
  getters: {
    getSelectIdents (state) {
      return state[types.SELECT_IDENTS]
    },
    getReceiverAddress (state) {
      return state[types.RECEIVER_ADDRESS]
    }
  }
}
export default purchase
